<template>
  <div>


    <!--<v-container fluid>-->
      <!--<v-row>-->
        <!--<v-col>-->
          <!--<vue-c3 :handler="handler1"></vue-c3>-->
        <!--</v-col>-->
        <!--<v-col>-->
          <!--<vue-c3 :handler="handler2"></vue-c3>-->
        <!--</v-col>-->
      <!--</v-row>-->
    <!--</v-container>-->



    <v-card light v-on:scroll.stop="" class="pt-2 pr-3">
      <div v-if="title" class="mytitle">
        {{title}}
      </div>
      <!--<vue-c3 :handler="handler"></vue-c3>-->
      <div :id="elemId"></div>
    </v-card>

    <!--<vue-c3 :handler="handler"></vue-c3>-->


  </div>
</template>

<style >

  .mytitle{
    padding-left: 20px;
    font-size: large;
    font-weight: bold;
    color: #5a5a5a;

  }

  .c3-xgrid, .c3-ygrid {
    stroke: #bdbdbd !important;
    stroke-width: 0.5;
  }


  /*.c3 path, .c3 line, .tick text {*/
    /*stroke: #8affe0;*/
    /*color: #ff7d54;*/

    /*!*fill: #9b72ea;*!*/
  /*}*/





  /*settings for dark mode*/
  /*path.domain {*/
    /*!*fill: white; *!*/
    /*stroke: white;*/
  /*}*/

  /*.tick text { fill: #ffffff; }*/
  /*.c3-legend-item text { fill: #d0d0d0; }*/


  .c3-circles-Actual{
    opacity: 1!important;
  }

</style>


<script>

   import * as d3 from 'd3';
   import c3 from 'c3';
   // import VueC3 from 'vue-c3';
   // import Vue from 'vue';
   import 'c3/c3.min.css'
   // import {DateTime} from 'luxon';
   // import axios from 'axios'



   export default {
      name: "chartCovid",
      // components: {VueC3, },
      // mixins: [data_getters],

      props: {
         data: Array,
         options: Object,
         title: String,
         elemId: String
      },
      data(){
         return {
            // handler: new Vue(),
            chart: null,
            c3_options : Object.assign({}, this.options),
         }
      },

      methods: {


         //hacky way to get the opacity for scatter plot points for the "Actual" series.  Note that this is hard coded
         // to this series name
         set_opacity(){
            setTimeout(()=>{
               d3.selectAll('.c3-circles-Actual circle')
                  // .style('color', '#ff3223')
                  // .style('fill', '#ff7fe5' )
                  .style('opacity', 1.0);
            }, 500)

         }

      },
      watch:{
         data () {
            let data = {
               columns: this.data,
            };

            // this.handler.$emit('dispatch', (chart) => chart.load(data))
            this.chart.load(data);

            // this.set_opacity();
         },

         // options(){
         //    // this.chart = this.chart.destroy();
         //    // console.log('chart', this.chart)
         //
         //    this.c3_options = Object.assign({}, this.options);
         //    this.c3_options.bindto = '#' + this.elemId;
         //    this.chart = c3.generate(this.c3_options);
         //
         //    console.log('chart', this.chart)
         //
         //
         //    let data = {
         //       columns: this.data,
         //    };
         //
         //    // this.handler.$emit('dispatch', (chart) => chart.load(data))
         //    this.chart.load(data)
         // }

      },

      mounted(){

         // this.handler.$emit('init', this.options);

         this.c3_options.bindto = '#' + this.elemId;
         this.chart = c3.generate(this.c3_options)

         let data = {
            columns: this.data,
         };

         // this.handler.$emit('dispatch', (chart) => chart.load(data))
         this.chart.load(data)
         // this.set_opacity();

      },

      beforeDestroy(){
         this.chart = this.chart.destroy();
      }


   }
</script>

